import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2, Sparkles } from "lucide-react";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { processOAuthCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL fragment
      const hash = location.hash;
      console.log("[AuthCallback] URL hash:", hash);
      const params = new URLSearchParams(hash.replace("#", ""));
      const sessionId = params.get("session_id");
      console.log("[AuthCallback] session_id:", sessionId);

      if (!sessionId) {
        console.error("[AuthCallback] No session_id found in URL");
        navigate("/login", { replace: true });
        return;
      }

      try {
        console.log("[AuthCallback] Processing OAuth callback...");
        await processOAuthCallback(sessionId);
        console.log("[AuthCallback] Success! Redirecting to dashboard...");
        // Redirect to dashboard
        navigate("/", { replace: true });
      } catch (error) {
        console.error("[AuthCallback] Auth callback error:", error);
        console.error("[AuthCallback] Error response:", error.response?.data);
        navigate("/login", { replace: true });
      }
    };

    processAuth();
  }, [location, navigate, processOAuthCallback]);

  return (
    <div className="min-h-screen bg-void flex items-center justify-center">
      <div className="text-center">
        <div className="relative inline-block">
          <Loader2 className="w-16 h-16 text-neon-cyan animate-spin" />
          <Sparkles className="w-6 h-6 text-neon-purple absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
        </div>
        <p className="mt-4 text-slate-400 font-rajdhani text-lg">
          Autenticando...
        </p>
      </div>
    </div>
  );
};
